import { render } from "./CrearPracticante.vue?vue&type=template&id=6fc691f6"
import script from "./CrearPracticante.vue?vue&type=script&lang=js"
export * from "./CrearPracticante.vue?vue&type=script&lang=js"

import "./CrearPracticante.vue?vue&type=style&index=0&id=6fc691f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__